import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';

// @ts-ignore
const bandeauCentralis = require('../../assets/logo/bandeau-centralis.png');

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFDFC'
  },
  bandeau: {
    width: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    paddingBottom: 16
  },
  userInfo: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'right'
  },
  dateInfo: {
    fontSize: 12,
    color: '#6B7280',
    textAlign: 'right',
    marginTop: 4
  },
  infoSection: {
    padding: 16,
    marginHorizontal: 24,
    marginBottom: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB'
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 8
  },
  infoLabel: {
    fontWeight: 'bold',
    width: '40%',
    fontSize: 11
  },
  infoValue: {
    flex: 1,
    fontSize: 11
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    padding: 12,
    marginHorizontal: 24,
    marginTop: 16,
    marginBottom: 8,
    borderRadius: 8
  },
  sectionContent: {
    marginHorizontal: 24,
    marginBottom: 16,
    padding: 12,
    backgroundColor: '#FFFDFC',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB'
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 4
  },
  fieldValue: {
    fontSize: 11,
    marginBottom: 12,
    lineHeight: 1.4
  },
  table: {
    marginTop: 12
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    minHeight: 24,
    alignItems: 'center'
  },
  tableHeader: {
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    fontWeight: 'bold'
  },
  tableCell: {
    flex: 1,
    fontSize: 10,
    padding: 6
  },
  tableCellNarrow: {
    width: 60,
    fontSize: 10,
    padding: 6
  },
  tableCellRight: {
    flex: 1,
    fontSize: 10,
    padding: 6,
    textAlign: 'right'
  },
  totalSection: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 12,
    paddingTop: 8,
    paddingRight: 6,
    borderTopWidth: 2,
    borderTopColor: '#E5E7EB'
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    marginRight: 8
  },
  totalValue: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 24,
    right: 24,
    fontSize: 10,
    color: '#6B7280',
    textAlign: 'center',
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB'
  },
  statusBadge: {
    marginVertical: 4,
    padding: 6,
    width: 120,
    textAlign: 'center',
    borderRadius: 20,
    fontSize: 10,
    fontWeight: 'bold'
  },
  honorairesSection: {
    backgroundColor: '#FFF7ED',
    padding: 12,
    marginTop: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#FED7AA'
  },
  honorairesText: {
    fontSize: 10,
    lineHeight: 1.4,
    marginBottom: 8
  },
  honorairesValue: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#EA580C'
  },
  signatureSection: {
    padding: 12,
  },
  signatureLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 8
  },
  signatureValue: {
    fontSize: 11,
    marginBottom: 4
  },
  signatureRole: {
    fontSize: 10,
    color: '#6B7280',
    fontStyle: 'italic'
  }

});

// Fonction pour obtenir les couleurs selon le statut
const getStatusStyle = (status: string) => {
  switch (status?.toLowerCase()) {
    case 'accepté':
      return { color: '#00A708', backgroundColor: 'rgba(0, 167, 8, 0.1)' };
    case 'refusé':
      return { color: '#D90E0E', backgroundColor: 'rgba(217, 14, 14, 0.1)' };
    case 'brouillon':
      return { color: '#6B7280', backgroundColor: 'rgba(107, 114, 128, 0.1)' };
    case 'en consultation':
      return { color: '#0486FF', backgroundColor: 'rgba(4, 134, 255, 0.1)' };
    case 'candidature soumise':
      return { color: '#00A708', backgroundColor: 'rgba(0, 167, 8, 0.1)' };
    case 'en attente':
      return { color: '#F4751B', backgroundColor: 'rgba(244, 117, 27, 0.1)' };
    case 'a valider':
      return { color: '#F4751B', backgroundColor: 'rgba(244, 117, 27, 0.1)' };
    default:
      return { color: '#6B7280', backgroundColor: 'rgba(107, 114, 128, 0.1)' };
  }
};

const SuiviCommandePDF = ({ commande, user }: { commande: any; user?: any }) => {
  const today = new Date().toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  const form = commande.formulaire || {};
  const operation = commande.operation || {};

  // 🔍 Console.log des données reçues par le PDF
  console.log('=== DONNÉES REÇUES PAR SuiviCommandePDF ===');
  console.log('📊 Commande complète:', commande);
  console.log('👤 User:', user);
  console.log('📝 Formulaire:', form);
  console.log('🔧 Operation:', operation);
  console.log('💰 Articles Prestataire:', commande.articlesPrestataire);
  console.log('📋 Articles:', commande.articles);
  console.log('📊 Critères:', commande.criteres);
  console.log('🏢 Status:', commande.status);
  console.log('📅 Dates importantes:', {
    created_at: commande.created_at,
    dateDebutOperation: form.dateDebutOperation || operation.date_debut_operation,
    dateFinOperation: form.dateFinOperation || operation.date_fin_operation
  });
  console.log('🗺️ Informations géographiques:', {
    departement: form.lotGeographique,
    region: form.regionName
  });
  console.log('=======================================');

  // Fonction pour formater les prix correctement
  const formatPrice = (price: number): string => {
    // Convertir d'abord le nombre en chaîne avec le format français
    const parts = price.toFixed(2).split('.');

    // Formater la partie entière avec des espaces tous les 3 chiffres
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    // Reconstruire le nombre avec la virgule française
    return `${integerPart},${parts[1]}`;
  };

  // Calcul du total HT
  const totalHT = (commande.articlesPrestataire || [])
    .reduce((sum: number, art: any) => sum + (art?.prixHT || 0), 0);

  // Calcul des honoraires (5%)
  const honoraires = totalHT * 0.05;

  console.log('💰 Calculs financiers:', {
    totalHT,
    honoraires,
    totalHTFormatted: formatPrice(totalHT),
    honorairesFormatted: formatPrice(honoraires)
  });

  // S'assurer que status existe
  const statusStyle = getStatusStyle(commande.status?.nom || commande.status || '');

  // Formatter la date de création
  const creationDate = commande.created_at
    ? new Date(commande.created_at).toLocaleDateString('fr-FR')
    : today;

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>


        {/* En-tête avec informations utilisateur et date */}
        <View style={styles.header} wrap={false}>
          <View>
            <Text style={styles.userInfo}>{user?.email || 'Utilisateur'}</Text>
            <Text style={styles.dateInfo}>Document généré le {today}</Text>
          </View>
        </View>

        {/* Informations générales sur la commande */}
        <View style={styles.infoSection} wrap={false}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Marché Subséquent</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>
              N° {commande.numeroDeCommande || commande.numero || `MS-${commande.id}`}
            </Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Département:</Text>
            <Text style={styles.infoValue}>{operation.lot_departement.departement.id || '-'} - {operation.lot_departement.departement.nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Lot technique :</Text>
            <Text style={styles.infoValue}>{operation.lot_technique.id || '-'} - {operation.lot_technique.nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date de création:</Text>
            <Text style={styles.infoValue}>{creationDate}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Statut:</Text>
            <View style={[styles.statusBadge, { backgroundColor: statusStyle.backgroundColor }]}>
              <Text style={{ color: statusStyle.color }}>{commande.status?.nom || commande.status || 'Brouillon'}</Text>
            </View>
          </View>
        </View>

        {/* Section Descriptif Administratif */}
        <Text style={styles.sectionTitle}>Descriptif Administratif</Text>
        <View style={styles.sectionContent} wrap={false}>
          <View>
            <Text style={styles.fieldLabel}>Nom de l'opération</Text>
            <Text style={styles.fieldValue}>{form.nomOperation || operation.nom || '-'}</Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Référence interne</Text>
            <Text style={styles.fieldValue}>{form.referenceInterne || operation.reference || '-'}</Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Adresse</Text>
            <Text style={styles.fieldValue}>
              {form.adresse || operation.adresse ?
                `${form.adresse || operation.adresse}, ${form.codePostal || operation.code_postal || ''} ${form.ville || operation.ville || ''}` :
                '-'
              }
            </Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Coordonnées maîtrise d'ouvrage</Text>
            <Text style={styles.fieldValue}>
              {form.coordonneesMaitriseDOuvrage || operation.coordonnees_maitrise_ouvrage || '-'}
            </Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Coordonnées maîtrise</Text>
            <Text style={styles.fieldValue}>
              {form.coordonneesMaitrise || operation.coordonnees_maitrise || '-'}
            </Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Facturation</Text>
            <Text style={styles.fieldValue}>{form.facturation || operation.facturation || '-'}</Text>
          </View>

          {(operation?.visite) && (
            <View>
              <Text style={styles.fieldLabel}>Conditions de visite</Text>
              <Text style={styles.fieldValue}>{operation?.conditionVisite || '-'}</Text>
            </View>
          )}

          <View>
            <Text style={styles.fieldLabel}>Dates</Text>
            <Text style={styles.fieldValue}>
              Délai de consultation: {form.delaisConsultation || operation.delais || '-'} jours
            </Text>
            <Text style={styles.fieldValue}>
              Délai fin d'opération: {form.delaisFinOperation || operation.delais || '-'} jours
            </Text>
            {(form.dateDebutOperation || operation.date_debut_operation) && (
              <Text style={styles.fieldValue}>
                Date de début d'opération: {
                  form.dateDebutOperation ?
                    new Date(form.dateDebutOperation).toLocaleDateString('fr-FR') :
                    operation.date_debut_operation ?
                      new Date(operation.date_debut_operation).toLocaleDateString('fr-FR') :
                      '-'
                }
              </Text>
            )}
            {(form.dateFinOperation || operation.date_fin_operation) && (
              <Text style={styles.fieldValue}>
                Date de fin d'opération: {
                  form.dateFinOperation ?
                    new Date(form.dateFinOperation).toLocaleDateString('fr-FR') :
                    operation.date_fin_operation ?
                      new Date(operation.date_fin_operation).toLocaleDateString('fr-FR') :
                      '-'
                }
              </Text>
            )}
          </View>
        </View>

        {/* Section Descriptif Technique */}
        <View wrap={false} break>
          <Text style={styles.sectionTitle}>Descriptif Technique</Text>
          <View style={styles.sectionContent}>
            <View>
              <Text style={styles.fieldLabel}>Définition du besoin</Text>
              <Text style={styles.fieldValue}>
                {operation.besoin || form.besoin || '-'}
              </Text>
            </View>

            {commande.reponseTechnique && (
              <View>
                <Text style={styles.fieldLabel}>Réponse Technique au Besoin</Text>
                <Text style={styles.fieldValue}>{commande.reponseTechnique}</Text>
              </View>
            )}

            {/* Critères techniques */}
            {commande.criteres?.organisation?.reponse && (
              <View>
                <Text style={styles.fieldLabel}>Critère Organisation</Text>
                <Text style={styles.fieldValue}>{commande.criteres.organisation.reponse}</Text>
              </View>
            )}

            {commande.criteres?.moyens?.reponse && (
              <View>
                <Text style={styles.fieldLabel}>Critère Moyens mis en œuvre</Text>
                <Text style={styles.fieldValue}>{commande.criteres.moyens.reponse}</Text>
              </View>
            )}

            {commande.criteres?.social?.reponse && (
              <View>
                <Text style={styles.fieldLabel}>Critère Social & Environnemental</Text>
                <Text style={styles.fieldValue}>{commande.criteres.social.reponse}</Text>
              </View>
            )}
          </View>
        </View>

        {/* Section Offre Financière */}
        <View wrap={false} break>
          <Text style={styles.sectionTitle}>Offre Financière</Text>
          <View style={styles.sectionContent}>
            {/* Tableau des articles */}
            <View style={styles.table}>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={styles.tableCellNarrow}>N°</Text>
                <Text style={styles.tableCell}>Description de la prestation</Text>
                <Text style={styles.tableCellRight}>Prix forfaitaire HT</Text>
              </View>

              {(commande.articles || []).map((article: any, index: number) => {
                const prix = commande.articlesPrestataire?.[index]?.prixHT || 0;
                return (
                  <View key={article.numero || index} style={styles.tableRow}>
                    <Text style={styles.tableCellNarrow}>{article.code}</Text>
                    <Text style={styles.tableCell}>{article.nom}</Text>
                    <Text style={styles.tableCellRight}>
                      {formatPrice(prix)} €
                    </Text>
                  </View>
                );
              })}
            </View>

            {/* Total */}
            <View style={styles.totalSection}>
              <Text style={styles.totalLabel}>Total DPGF HT:</Text>
              <Text style={styles.totalValue}>
                {formatPrice(totalHT)} €
              </Text>
            </View>

            {/* Section honoraires */}
            <View style={styles.honorairesSection}>
              <Text style={styles.honorairesText}>
                Pour mémoire, conformément aux pièces du marché et aux conditions générales acceptées,
                Centralis facturera 5% de commissions sur le montant de l'offre HT.
              </Text>
              <Text style={styles.honorairesValue}>
                Honoraires évalués à : {formatPrice(honoraires)} € HT
              </Text>
            </View>

          </View>
        </View>

        <View wrap={false}>
          <Text style={styles.sectionTitle}>Informations de signature</Text>
          <View style={styles.sectionContent}>
            <View style={styles.signatureSection}>
              {commande.prestataire_signataire ? (
                <>
                  <Text style={styles.signatureLabel}>Signataire</Text>
                  <Text style={styles.signatureValue}>
                    {commande.prestataire_signataire.prenom} {commande.prestataire_signataire.nom}
                  </Text>
                  <Text style={styles.signatureRole}>
                    {commande.prestataire_signataire.email || 'Email non défini'} {/* Remplacer fonction par email */}
                  </Text>
                </>
              ) : (
                <Text style={styles.signatureValue}>Non défini</Text>
              )}
            </View>
            <Text>
              Nous attirons votre attention sur l'importance de l'exactitude du nom, et prénom du signataire qui sera vérifié par notre partenire Yousign pour la signature éléctronique
            </Text>
          </View>
        </View>

        {/* Pied de page */}
        <Text style={styles.footer} fixed render={({ pageNumber, totalPages }) => (
          `Document généré par Centralis • ${today} • ${user?.email || ''} • Page ${pageNumber}/${totalPages}`
        )} />
      </Page>
    </Document>
  );
};

export default SuiviCommandePDF;